import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { F, Button, Flex } from 'nallian-shared-ui/lib/components';
import App from './App';

const FieldFlex = styled(Flex)`
  && .field {
    width: 100%;
  }
`;

const FieldLabel = styled.label`
  margin: 0 0 0.28571429rem 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
`;

const AppFields = ({ apps, fields, submitProcessing, readOnly, editMode }) => {
  const { t } = useTranslation();

  const handleAddFieldClick = useCallback(
    () => fields.push({ isNew: true, requiresSubscription: true }),
    [fields]
  );
  const handleRemoveFieldClick = useCallback((_, { i }) => fields.remove(i), [fields]);

  return (
    <F.Field error={false}>
      <Flex fluid direction="column">
        <FieldLabel htmlFor="-">{t('apps_plural')}</FieldLabel>
        <FieldFlex fluid direction="column" alignItems="flex-start">
          {fields.map((f, index) => (
            <App
              apps={apps}
              index={index}
              fields={fields}
              editMode={editMode}
              field={f}
              readOnly={readOnly}
              key={`app_${index.toString()}`}
              handleRemoveFieldClick={handleRemoveFieldClick}
              submitProcessing={submitProcessing}
            />
          ))}
          {!fields.length && (
            <Flex margin="1rem 0 0">{t('noAppsConfiguredForOnboardingTemplate')}</Flex>
          )}
          {!readOnly && fields.length < apps?.length && (
            <Flex fluid justifyContent="flex-end" margin="1rem 0 0 0">
              <Button
                linkbutton
                icon="add"
                type="button"
                tabindex="-1"
                content={t('addApp')}
                onClick={handleAddFieldClick}
              />
            </Flex>
          )}
        </FieldFlex>
      </Flex>
    </F.Field>
  );
};

AppFields.propTypes = {
  fields: PropTypes.array.isRequired,
  submitProcessing: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  editMode: PropTypes.bool,
  apps: PropTypes.array,
};

AppFields.defaultProps = { apps: [], editMode: false };

export default AppFields;
